import React from "react";
import { cn } from "utils";

type AvatarProps = {
  className?: string;
  fallback?: string;
  url?: string;
};
export const Avatar = ({ className, url, fallback = "" }: AvatarProps) => {
  if (url) {
    return (
      <img
        src={url}
        alt={url}
        className={cn("w-11 h-11 rounded-full object-cover", className)}
      />
    );
  }

  if (!fallback) {
    return (
      <img
        src="https://via.placeholder.com/500"
        alt=""
        className={cn("h-[50px] rounded-full", className)}
      />
    );
  }

  const [firstName, lastName] = fallback.split(" ");

  return (
    <div
      className={cn(
        "size-11 rounded-full bg-gray font-bold justify-center items-center flex bg-primary/20",
        className
      )}>
      {firstName?.[0]?.toUpperCase()}
      {lastName?.[0]?.toUpperCase()}
    </div>
  );
};
